import { t as gsapWithCSS } from "@theme/gsap";
//#region frontend/islands/ingredient-tabs.js
var IngredientTabs = class extends HTMLElement {
	connectedCallback() {
		this.panels = [...this.querySelectorAll("[data-recipe-id]")];
		this.buttons = [];
		this.tabContainer = this.querySelector("[data-tab-container]");
		this.activeIndex = 0;
		this.panels.forEach((panel, i) => {
			const id = panel.getAttribute("data-recipe-id");
			const button = document.createElement("button");
			button.setAttribute("type", "button");
			button.setAttribute("role", "tab");
			button.setAttribute("id", `tab-${id}`);
			button.setAttribute("aria-selected", i === 0 ? "true" : "false");
			button.setAttribute("tabindex", i === 0 ? "0" : "-1");
			button.setAttribute("aria-controls", `panel-${id}`);
			button.setAttribute("data-tab-id", id);
			button.classList.add("text-h5", "border-pine", "border-thick", "rounded-full", "capitalize", "p-gutter-sm", "pr-gutter-md", "flex", "flex-row", "items-center", "justify-center", "md:gap-x-gutter-sm", "cursor-pointer", "hover:bg-pine", "hover:text-cream", "transition-all", "duration-300", "shrink-0", "min-w-[150px]", "whitespace-nowrap", "gap-x-gutter", i !== 0 ? "bg-transparent" : "bg-pine", i !== 0 ? "text-pine" : "text-cream");
			const src = panel.getAttribute("data-recipe-image");
			const alt = panel.getAttribute("data-recipe-name");
			button.innerHTML = `
        <img
          class="h-12 w-12"
          src="${src}"
          width="48"
          height="48"
          alt="${alt}"
          loading="eager"
          fetchpriority="${i === 0 ? "high" : "auto"}"
        />
        <span>${alt}</span>
      `;
			button.addEventListener("click", () => this.switchTo(i));
			this.tabContainer.append(button);
			this.buttons.push(button);
			if (i !== 0) {
				gsapWithCSS.set(panel, { opacity: 0 });
				panel.classList.add("panel-hidden");
				panel.setAttribute("aria-hidden", "true");
			}
		});
		this.tabContainer.addEventListener("keydown", (e) => this.handleKeydown(e));
		this.syncToActiveRecipe();
		this._onRecipeChange = (e) => this.switchToRecipe(e.detail.recipeName);
		document.addEventListener("recipe:change", this._onRecipeChange);
		this._onBlockSelect = (e) => {
			const idx = this.panels.findIndex((p) => p.dataset.recipeId === e.detail.blockId);
			if (idx !== -1) this.switchTo(idx);
		};
		document.addEventListener("shopify:block:select", this._onBlockSelect);
	}
	disconnectedCallback() {
		document.removeEventListener("recipe:change", this._onRecipeChange);
		document.removeEventListener("shopify:block:select", this._onBlockSelect);
	}
	handleKeydown(e) {
		const map = {
			ArrowRight: 1,
			ArrowLeft: -1
		};
		if (e.key === "Home") {
			e.preventDefault();
			this.buttons[0].focus();
			this.switchTo(0);
		} else if (e.key === "End") {
			e.preventDefault();
			const last = this.buttons.length - 1;
			this.buttons[last].focus();
			this.switchTo(last);
		} else if (e.key in map) {
			e.preventDefault();
			const next = (this.activeIndex + map[e.key] + this.buttons.length) % this.buttons.length;
			this.buttons[next].focus();
			this.switchTo(next);
		}
	}
	switchToRecipe(name) {
		const index = this.panels.findIndex((p) => p.getAttribute("data-recipe-name")?.toLowerCase() === name?.toLowerCase());
		this.switchTo(index >= 0 ? index : 0);
	}
	syncToActiveRecipe() {
		const picker = document.querySelector("product-recipe-picker:not(product-alternatives-drawer product-recipe-picker)");
		if (!picker) return;
		const activeBtn = picker.querySelector("button[aria-checked='true']");
		if (!activeBtn) return;
		const recipeName = activeBtn.dataset.recipeValue;
		if (!recipeName) return;
		const index = this.panels.findIndex((p) => p.getAttribute("data-recipe-name").toLowerCase() === recipeName.toLowerCase());
		if (index <= 0) return;
		const outPanel = this.panels[0];
		const outButton = this.buttons[0];
		gsapWithCSS.set(outPanel, { opacity: 0 });
		outPanel.classList.add("panel-hidden");
		outPanel.setAttribute("aria-hidden", "true");
		outButton.setAttribute("aria-selected", "false");
		outButton.setAttribute("tabindex", "-1");
		outButton.classList.remove("bg-pine", "text-cream");
		outButton.classList.add("bg-transparent", "text-pine");
		const inPanel = this.panels[index];
		const inButton = this.buttons[index];
		gsapWithCSS.set(inPanel, { opacity: 1 });
		inPanel.classList.remove("panel-hidden");
		inPanel.removeAttribute("aria-hidden");
		inButton.setAttribute("aria-selected", "true");
		inButton.setAttribute("tabindex", "0");
		inButton.classList.remove("bg-transparent", "text-pine");
		inButton.classList.add("bg-pine", "text-cream");
		this.activeIndex = index;
	}
	switchTo(index) {
		if (index === this.activeIndex) return;
		const outPanel = this.panels[this.activeIndex];
		const outButton = this.buttons[this.activeIndex];
		const inPanel = this.panels[index];
		const inButton = this.buttons[index];
		gsapWithCSS.to(outPanel, {
			opacity: 0,
			duration: .25,
			onComplete: () => {
				outPanel.classList.add("panel-hidden");
				outPanel.setAttribute("aria-hidden", "true");
				inPanel.classList.remove("panel-hidden");
				inPanel.removeAttribute("aria-hidden");
				gsapWithCSS.to(inPanel, {
					opacity: 1,
					duration: .35
				});
			}
		});
		outButton.setAttribute("aria-selected", "false");
		outButton.setAttribute("tabindex", "-1");
		outButton.classList.remove("bg-pine", "text-cream");
		outButton.classList.add("bg-transparent", "text-pine");
		inButton.setAttribute("aria-selected", "true");
		inButton.setAttribute("tabindex", "0");
		inButton.classList.remove("bg-transparent", "text-pine");
		inButton.classList.add("bg-pine", "text-cream");
		this.activeIndex = index;
	}
};
customElements.define("ingredient-tabs", IngredientTabs);
//#endregion
